import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {it_valutation} from './it/valutation';
import {it_mapping} from './it/mapping';
import {it_auction} from './it/auction';
import {it_operation} from './it/operation';
import {it_breadcrumbing} from './it/breadcrumbing';
import {it_todo} from './it/todo';
import {it_income} from './it/income';
import {it_info} from './it/info';
import {it_team} from './it/team';
import {it_calendar} from './it/calendar';
import {it_event} from './it/event';
import {it_dashboard} from './it/dashboard';
import {it_idealista} from './it/idealista';
import {it_immobiliare} from './it/immobiliare';
import {it_custom} from './it/custom';
import {it_upload} from './it/upload';
import {it_login} from './it/login';
import {it_purpose} from './it/purpose';

import {es_valutation} from './es/valutation';
import {es_mapping} from './es/mapping';
import {es_auction} from './es/auction';
import {es_operation} from './es/operation';
import {es_breadcrumbing} from './es/breadcrumbing';
import {es_todo} from './es/todo';
import {es_income} from './es/income';
import {es_info} from './es/info';
import {es_team} from './es/team';
import {es_calendar} from './es/calendar';
import {es_event} from './es/event';
import {es_dashboard} from './es/dashboard';
import {es_idealista} from './es/idealista';
import {es_immobiliare} from './es/immobiliare';
import {es_custom} from './es/custom';
import {es_upload} from './es/upload';
import {es_login} from './es/login';
import {es_purpose} from './es/purpose';

var simulate = 'it';
var lang = window.localStorage.getItem('language');

if (lang && lang.length > 0)
{
    simulate = lang;
}

if (simulate == 'es') {
    var valutation = es_valutation;
    var mapping = es_mapping;
    var auction = es_auction;
    var operation = es_operation;
    var todo = es_todo;
    var breadcrumb = es_breadcrumbing;
    var income = es_income;
    var info = es_info;
    var team = es_team;
    var calendar = es_calendar;
    var event = es_event;
    var dashboard = es_dashboard;
    var idealista = es_idealista;
    var immobiliare = es_immobiliare;
    var custom = es_custom;
    var upload = es_upload;
    var login = es_login;
    var purpose = es_purpose;
}
else {

    var valutation = it_valutation;
    var mapping = it_mapping;
    var auction = it_auction;
    var operation = it_operation;
    var todo = it_todo;
    var breadcrumb = it_breadcrumbing;
    var income = it_income;
    var info = it_info;
    var team = it_team;
    var calendar = it_calendar;
    var event = it_event;
    var dashboard = it_dashboard;
    var idealista = it_idealista;
    var immobiliare = it_immobiliare;
    var custom = it_custom;
    var upload = it_upload;
    var login = it_login;
    var purpose = it_purpose;
}

Vue.use(VueI18n);
const messages = {
    it: {
        valutation,
        mapping,
        auction,
        operation,
        breadcrumb,
        todo,
        income,
        info,
        team,
        calendar,
        event,
        dashboard,
        idealista,
        immobiliare,
        custom,
        upload,
        login,
        purpose

    }

};

// Create VueI18n instance with options
export const i18n = new VueI18n({
    locale: 'it', // set locale
    messages, // set locale messages
});


// // Create a Vue instance with `i18n` option
// new Vue({ i18n }).$mount('#app')
